import { z } from 'zod';
export const emailSchema = z
    .string()
    .trim()
    .max(254)
    .pipe(z.email({ error: 'Неверный адрес почты' }))
    .transform((v) => v.toLowerCase());
export const nameSchema = z.string().trim().min(1, 'Укажите имя').max(80);
/** 8+ символов, как в дизайне (минимум NIST 800-63B); длина важнее «сложности». */
export const passwordSchema = z.string().min(8, 'Пароль — не короче 8 символов').max(256);
/** Относительный путь внутри приложения для возврата после входа (защита от open redirect). */
export const redirectSchema = z
    .string()
    .max(512)
    .regex(/^\/(?!\/)[^\s\\]*$/, 'Только путь внутри приложения')
    .optional();
export const colorSchema = z.string().regex(/^#[0-9a-fA-F]{6}$/, 'Цвет в формате #rrggbb');
export const slugSchema = z
    .string()
    .trim()
    .toLowerCase()
    .min(3)
    .max(40)
    .regex(/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/, 'Латиница, цифры и дефис');
//# sourceMappingURL=common.js.map